<template>
  <div class="card commodity-info" v-if="orderDetail.deliveryMode == '1'">
    <div class="info">
      <div class="info-header">{{title}}</div>
      <van-row class="info-line">
        <van-col :span="12">
          <div class="info-title">运单号：<span class="info-title">{{orderDetail.shipNo}}</span></div>
        </van-col>
        <van-col :span="12">
          <div class="info-title">承运商：<span class="info-title">{{orderDetail.shipNo}}</span></div>
        </van-col>
        <!-- <van-col :span="19">
          <div class="info-value">
            <van-radio-group v-model="deliveryType" direction="horizontal">
              <van-radio name="1">管输</van-radio>
            </van-radio-group>
          </div>
        </van-col> -->
      </van-row>
      <van-row class="info-line" >
        <van-col :span="12">
          <div class="info-title">车辆类型：{{ orderDetail.trunkType }}</div>
        </van-col>
        <van-col :span="12">
          <div class="info-title">车型：{{ orderDetail.warehouseAddress }}</div>
        </van-col>
      </van-row>
      <van-row class="info-line" >
        <van-col :span="12">
          <div class="info-title">车船号：{{ orderDetail.trunkType }}</div>
        </van-col>
        <van-col :span="12">
          <div class="info-title">挂车号：{{ orderDetail.warehouseAddress }}</div>
        </van-col>
      </van-row>
      <van-row class="info-line" >
        <van-col :span="24">
          <div class="info-title">司机：{{ orderDetail.trunkType }}</div>
        </van-col>
      </van-row>
      <van-row class="info-line">
        <van-col :span="24">
          <div class="info-title">司机身份证号：{{ orderDetail.warehouseAddress }}</div>
        </van-col>
      </van-row>
      <van-row class="info-line">
        <van-col :span="24">
          <div class="info-title">司机手机号：{{ orderDetail.warehouseContactName }}</div>
        </van-col> 
      </van-row>
       <van-row class="info-line">
        <van-col :span="24">
          <div class="info-title">押运员：{{ orderDetail.warehouseAddress }}</div>
        </van-col>
      </van-row>
      <van-row class="info-line">
        <van-col :span="24">
          <div class="info-title">押运员身份证号：{{ orderDetail.warehouseContactName }}</div>
        </van-col> 
      </van-row>
      <van-row class="info-line">
        <van-col :span="24">
          <div class="info-title">押运员手机号：{{ orderDetail.warehouseContactName }}</div>
        </van-col> 
      </van-row>
      <van-row class="info-line">
        <van-col :span="24">
          <div class="info-title">提货重量：{{ orderDetail.warehouseContactName }}</div>
        </van-col> 
      </van-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderDeliveryTypeCard",
  props: {
    orderDetail: Object,
    title: {
      type: String,
      default: "承运信息",
    },
  },
  data() {
    return {
      deliveryType: "1",
    };
  },
  filters: {
    shipModeStatus: function (value) {
      switch (value) {
        case "Z":
          return "直发";
        case "K":
          return "库发";
        case "D":
          return "断卖";
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/styles/varibles.styl';

.card {
  margin-top: 24px;
  background: #ffffff;
  padding: 0 24px;
  font-size: 26px;

  .info {
    padding: 16px 0;

    .info-header {
      display: flex;
      justify-content: right;
      align-items: center;
      height: 88px;
      font-size: 32px;

      img {
        width: 40px;
        height: 40px;
        margin-right: 12px;
      }
    }

    .info-line >>> .van-radio {
      .van-radio__icon {
        font-size: 24px;
      }

      .van-radio__label {
        line-height: 54px;
      }
    }

    .info-line {
      line-height: 54px;
      color: #666666;
    }
  }
}
</style>